import apiService from '../../../../services/api/ApiService';
import utilService from '../../../../services/UtilService';

const spreadSheetInteractionSelector = {

    async openExcelInWindowSignal(questionId, wopiUrl) {
        if (utilService.isIep()) {
            try {
                await apiService.sendOpenExcelWindowSignal(questionId);
            } catch (error) {
                console.error('Error sending open Excel in window signal:', error);
            }
        } else {
            utilService.openInNewWindow(wopiUrl);
        }
    },

    excelIconSrc: 'https://res-1.cdn.office.net/files/fabric-cdn-prod_20251008.001/assets/brand-icons/product/svg/excel_32x1.svg',
};

export default spreadSheetInteractionSelector;
